import { TrainingPicture } from "@/types/creatorcenter";
import {
  Box,
  Flex,
  Image as ChakraImage,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { RiCloseCircleLine } from "@remixicon/react";
import { useState } from "react";
import MarkingPictureModal from "./markingPictureModal";
import TransitionDialog from "../alertDialog";

type Props = {
  picture: TrainingPicture;
  onDelete: ()=>void;
};

const TrainingPictureItem = (props: Props) => {
  const { picture, onDelete} = props;
  const markingControl = useDisclosure();
  const DialogControl = useDisclosure();
  const [hoverd, setHoverd] = useState<boolean>(false);

  const handleClickPic = () => {
    markingControl.onOpen();
  };

  return (
    <>
      <Box
        w="160px"
        h="160px"
        mr="10px"
        bg={"rgba(238, 241, 247, 0.5)"}
        position="relative"
        onMouseEnter={() => setHoverd(true)}
        onMouseLeave={() => setHoverd(false)}
      >
        <ChakraImage
          boxSize={"160px"}
          objectFit="cover"
          src={picture.file_path}
        />
        {!hoverd && (
          <Box
            w="100%"
            h="100%"
            bg="linear-gradient(180deg, rgba(0, 0, 0, 0.4) 6%, rgba(0, 0, 0, 0) 15%, rgba(0, 0, 0, 0) 81%, rgba(0, 0, 0, 0.4) 95%)"
            position={"absolute"}
            top={0}
            left={0}
          >
            <Flex
              h="100%"
              flexDirection={"column"}
              p="5px"
              justifyContent="space-between"
            >
              <Box color={"#fff"} fontSize="12px">

                {picture.width ? picture.width+"*"+picture.height :<></>}
              </Box>
              {picture.file_content?  (
                <Box
                  w="100%"
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  color={"#fff"}
                  fontSize="12px"
                >
                  {picture.file_content}
                </Box>
              ) :<></>}
            </Flex>
          </Box>
        )}

        {hoverd && (
          <>
            <Box
              w="100%"
              h="100%"
              bg="rgba(0, 0, 0, 0.4)"
              position={"absolute"}
              top={0}
              left={0}
              onClick={handleClickPic}
              cursor="pointer"
            ></Box>
            <IconButton
              variant="unstyled"
              aria-label="delete"
              fontSize="16px"
              position={"absolute"}
              top="10px"
              right={"10px"}
              w="16px"
              minW={"16px"}
              h="16px"
              icon={<RiCloseCircleLine color="#FFFFFF" size={"20px"} />}
              onClick={DialogControl.onOpen}
            />
          </>
        )}
      </Box>
      <MarkingPictureModal
        isOpen={markingControl.isOpen}
        onClose={markingControl.onClose}
        imgSrc={picture.file_path}
      />
      {
        picture && <TransitionDialog 
        isOpen={DialogControl.isOpen} onClose={DialogControl.onClose} onDelete={onDelete}/>
      }
    </>
  );
};

export default TrainingPictureItem;
